import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import MuiGrid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

const Popup = ({
    onApplyChanges,
    open,
    setShowEditingPopup,
    column,
  }) => {

    const [changeValue, setChangeValue] = useState('');
    const [typeChangeValue, setTypeChangeValue] = useState();

    const saveChanges = () => {
      onApplyChanges(changeValue, typeChangeValue)
      setChangeValue('')
      setTypeChangeValue('')
      setShowEditingPopup(false)
    }

    return (
      <Dialog open={open} onClose={() => setShowEditingPopup(false)} aria-labelledby="form-dialog-title" fullWidth={true}>
          <DialogTitle id="form-dialog-title"><span style={{color: "#000"}}>Alterar valores da coluna</span></DialogTitle>
        <DialogContent >
          <MuiGrid>
            <TextField
              margin="normal"
              name="value"
              type="number"
              label="Valor em %"
              value={changeValue}
              onChange={(e) => setChangeValue(e.target.value)}
            />
            <MuiGrid item xs={6} direction="row">
              <RadioGroup
                aria-label="gender"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={(element) => setTypeChangeValue(element.target.value)} >
                <FormControlLabel value="increase" control={<Radio />} label="Aumentar" />
                <FormControlLabel value="decrease" control={<Radio />} label="Diminuir" />
              </RadioGroup>
            </MuiGrid>
          </MuiGrid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowEditingPopup(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={() => saveChanges()} color="primary">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    )
}

export default Popup
